import { React, useState, useEffect } from "react";
import {
  getColor,
  getIcon,
  formatNumber,
} from "../../constants/commonFunction";
import BigBox from "../BigBox.js";
import Box from "../Box.js";

const ContractorCountStatus = (props) => {
  const [data, setData] = useState([]);
  const [count, setCount] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (props?.count) {
      setCount(props?.count);
    }
  }, [props?.count]);

  // const contractorCount = count;

  useEffect(() => {
    setLoading(true);
    let arr = [];
    for (let [key, value] of Object.entries(count)) {
      if (
        String(key).includes("dormant_contractors_count") ||
        String(key).includes("inactive_contractors_count") ||
        String(key).includes("deactivated_contractors_count") ||
        String(key).includes("stagnant_contractors_count")
      ) {
        arr.push({
          color: getColor(key),
          value: value,
          label: String(
            key.split("_").slice(0, -2).join(" ") + " Contractor"
          ).replace(/\b\w/g, (char) => char.toUpperCase()),
        });
      }
    }
    setData(arr);
    setLoading(false);
  }, [count]);

  return (
    <>
      <BigBox header={"Non - active Contractors"}>
        {loading ? (
          <div
            style={{
              padding: "16px",
              display: "flex",
              justifyContent: "center",
              color: "#000",
              maxHeight: "112px",
              minWidth: "202px",
              minHeight: "112px",
            }}
          >
            <p>Loading...</p>
          </div>
        ) : data?.length > 0 ? (
          data.map((item, index) => {
            return (
              <>
                <Box bgColor={item?.color}>
                  <p
                    className="text-[18px] font-bold"
                    style={{
                      color: item?.label.includes("dormant")
                        ? "#F98B04"
                        : item?.label.includes("inactive")
                        ? "#FF0018"
                        : item?.label.includes("stagnant")
                        ? "#FFA600"
                        : "#931517",
                    }}
                  >
                    {item?.value}
                  </p>
                  <p>{item?.label}</p>
                </Box>
              </>
            );
          })
        ) : (
          <div
            style={{
              padding: "16px",
              display: "flex",
              justifyContent: "center",
              color: "#000",
              maxHeight: "112px",
              minWidth: "202px",
              minHeight: "112px",
            }}
          >
            <p>No data found !!!</p>
          </div>
        )}
      </BigBox>
    </>
  );
};

export default ContractorCountStatus;
